export const CARD_TYPE = 'cardType';
export const TABS_TYPE = 'tabsType';
export const PAGINATION_TYPE = 'paginationType';
export const DATE_FORMATTING = 'dateFormatting';
export const STRATEGY_SERVICE = 'StrategyService';
export const SEARCHERS = 'searchers';
export const INTERNAL_ADDRESSES = 'internalAddresses';
export const HIDE_LABELS = 'hideLabels';

export const BASE_URLS = 'baseUrls';
export const CONVERSATIONAL_SEARCH = 'conversationalSearch';
export const TRANSFORM_EVENTS_NAMES = 'transformEventsNames';

export const PASS_FACET_INFO = 'passFacetInfo';
export const EXST_LABELS = 'exstLabels';

export const GUIDED_V2_SERVICE = 'guidedV2';
export const PRECACHING_SERVICE = 'queryPrecaching';
